import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useLocationStore = defineStore('location', {
  state: () => ({
    location: {
      id:  null,
      title: null,
      street1: null,
      street2: null,
      city: null,
      state: null,
      zip: null,
      phone1: null,
      phone2: null,
      email: null,
      fax: null,
      website: null,
      description: null,
    }
  }),

  actions: {
    async fetch({ locationId }) {
      return httpClient.get(`/api/internal/locations/${locationId}`)
        .then(({ data: { location } }) => {
          this.location = location
        })
    },

    async save() {
      return await this.location.id ? this.update() : this.create()
    },

    async create() {
      const { location } = this

      return httpClient
        .post('/api/internal/locations', {
          location
        })
        .then((resp) => {
          const { data: { status, location } } = resp
          if (status == 'success') {
            this.location = location
            useMessagesStore().addNotice(`${location.title} location created`)
          }

          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)

          throw err
        })
    },

    async update() {
      const { location } = this

      return httpClient
        .patch(`/api/internal/locations/${location.id}`, {
          location
        })
        .then((resp) => {
          const { data: { location } } = resp

          this.location = location
          useMessagesStore().addNotice(`${location.title} location saved`)

          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)

          throw err
        })
    }
  }
})
